import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { DynamicFormOptions } from "./models/edit-fields";
import { DynamicFormApi } from "./services/dynamic-form.api";
import { Observable } from "rxjs";
import { first, finalize } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-dynamic-form-container",
    templateUrl: "./dynamic-form.container.html",
    styleUrls: ["./dynamic-form.container.scss"],
    standalone: false
})
export class DynamicFormContainer implements OnInit {
  @Input() dynamicFormOptions: DynamicFormOptions;

  formInitialData$: Observable<any>;
  formInitialData: any;
  isSubmitting: boolean = false;
  successMessage:string = null;

  constructor(private dynamicFormApi: DynamicFormApi, private toastrService: ToastrService) {}

  onFormSubmitted(form: UntypedFormGroup) {
    this.successMessage = '';
    this.isSubmitting = true;
    this.dynamicFormApi
      .postForm(form, this.dynamicFormOptions)
      .pipe(
        first(),
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        (res) => {
 
          if (this.dynamicFormOptions.saveFormSuccessMethod === "ShowJsonMessage") {
            this.successMessage = this.showJsonHtml(JSON.stringify(res, null, 2));
          } else {
            this.toastrService.success('', "Saved");
            window.location.reload();
          }
        },
        (err) => {
          this.toastrService.error("", "Error saving");
        }
      );
  }
   public showJsonHtml(result:any) {
    if(result === undefined) return null;
    return result.replaceAll('\n', '<br/>  ').replaceAll(' ', '&nbsp;');
  }

  onItemDeleted() {
    this.isSubmitting = true;
    this.dynamicFormApi
      .delete(this.dynamicFormOptions)
      .pipe(
        first(),
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        () => {
          this.toastrService.success("", "Deleted");
          window.location.reload();
        },
        (err) => {
          this.toastrService.error("", "Error deleting");
        }
      );
  }

  ngOnInit() {
    if (this.dynamicFormOptions.getFormUrl) {
      this.formInitialData$ = this.dynamicFormApi.get(this.dynamicFormOptions);
      this.formInitialData$.pipe(first()).subscribe((initialData) => {
        this.formInitialData = initialData;
      });
    }
  }
}
